import ToggleFemaleOnlyQuestions from './ToggleFemaleOnlyQuestions';

export default ToggleFemaleOnlyQuestions;
